import React from "react";
import CodeBuddy from "./CodeBuddy";

function App() {
  return <CodeBuddy />;
}

export default App;
